// Read-only counterpart to TextField/SelectBox — view mode shows this
// instead of a disabled input, edit mode shows the real field. A disabled
// input still looks editable (border, background) and invites clicking; this
// makes the two modes visually distinct instead of everything always looking
// like a form. Originally local to employee-profile.component.tsx, extracted
// here once customer-profile.component.tsx needed the same thing.
//
// Styling note: .input-wrapper/.display-value/.input-label are defined
// nested under .user-info-container in user-profile-sidemodal.style.scss
// (shared by employee-profile/customer-profile/add-employee-wizard) — render
// this inside a .user-info-container ancestor, or .display-value will paint
// unstyled.
interface DisplayFieldProps {
	label: string;
	value?: string | null;
	// e.g. "cap-display" to capitalize a name — kept separate from a fixed
	// style on .display-value since not every field wants the same treatment.
	valueClassName?: string;
}

function DisplayField({ label, value, valueClassName }: DisplayFieldProps) {
	return (
		<div className="input-wrapper">
			<label className="input-label">{label}</label>
			<div className={`display-value${valueClassName ? ` ${valueClassName}` : ""}`}>
				{value || "—"}
			</div>
		</div>
	);
}

export default DisplayField;

// Resolves a SelectBox-style { id, value } option list (see strings.js) down
// to its display label — DisplayField's counterpart for select-backed fields
// (role, gender, city, ...), which otherwise only carry the raw stored id.
export function getOptionLabel(
	options: { id: string; value: string }[],
	id?: string | null,
) {
	return options.find((option) => option.id === id)?.value ?? "—";
}
